import { IEnvConfig } from '..';

const config: IEnvConfig = {
  name: 'PRODUCTION',
  CONNECTORS: {
    ROOT: {
      baseUrl: 'https://strapi-dev.apetechs.co/'.trim(),
      apiToken: import.meta.env.VITE_TOKEN
    },
   
  },
};

export default config;
